import { Outlet, useLocation } from 'react-router-dom';
import { AppSidebar } from './app-sidebar';
import { Breadcrumb } from '@/components/ui/breadcrumb';
import { useBreadcrumbs } from '@/hooks/use-breadcrumbs';
import { SidebarProvider } from '@/contexts/sidebar-context';
import { DataModeBadge } from '@/components/DataModeBadge';
import { AIAssistantButton, AIAssistantPanel } from '@/components/ai-assistant';

export function AppLayout() {
  const location = useLocation();
  const breadcrumbs = useBreadcrumbs();
  
  // Hide breadcrumbs on home page and dashboard pages
  const isDashboardPage = location.pathname === '/' || 
                          location.pathname === '/collections/dashboard' || 
                          location.pathname === '/disputes';
  const showBreadcrumbs = !isDashboardPage;
  const isScreenDataModesPage = location.pathname === '/settings/screen-data-modes';

  return (
    <SidebarProvider>
      <div className="flex h-screen bg-muted/40">
        <AppSidebar />
        <main className="flex-1 flex flex-col overflow-hidden">
          {showBreadcrumbs && (
            <div className="shrink-0 z-10 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b">
              <div className="flex items-center justify-between px-6 py-3">
                <Breadcrumb items={breadcrumbs} />
                <div className="flex items-center gap-2">
                  {!isScreenDataModesPage && <DataModeBadge />}
                </div>
              </div>
            </div>
          )}
          <div className="flex-1 min-h-0 overflow-y-auto">
            <Outlet />
          </div>
        </main>
        <AIAssistantPanel />
      </div>
    </SidebarProvider>
  );
}
